import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export enum Language {
  English = "en",
  French = "fr",
}

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: Language.English, // Fallback language if detection fails
    ns: [
      "common",
      "modal",
      "form",
      "alert",
      "banner",
      "button",
      "card",
      "chip",
      "component",
      "field",
      "menu",
      "page",
      "panel",
      "route",
      "table",
      "tooltip",
      "media",
    ],
    defaultNS: "common",
    detection: {
      order: ["localStorage"], // Only use localStorage to detect language
      caches: ["localStorage"], // Cache the user's language in local storage
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
